export const Dashboards =
{
    "content": [
        {
            "title": "hDRG Spatial Transcriptomics and Neuropathic Pain",
            "description": "This RShiny site contains data sets across two complementary papers. In “Mapping Human Nociceptors” we identify transcriptomic signatures of nociceptors. The second data set looks at sex differences in underlying mechanisms of neuropathic pain.",
            "link": "https://sensoryomics.shinyapps.io/RNA-Data/",
            "imageUrl": "entrepreneurship-banner.jpg",
            "paperLinks": [
                "https://pubmed.ncbi.nlm.nih.gov/35171654",
                "https://doi.org/10.1093/brain/awac266"
            ]
        },
        {
            "title": "hDRG Long Read Sequencing",
            "description": "This RShiny site is a companion dashboard for “Isoform expression patterns in the human DRG”. This resource is intended for researchers in the pain and neuroscience field to understand how splicing contributes to neuropathies and chronic pain disorders.",
            "link": "https://sensoryomics.shinyapps.io/RNAIsoforms/",
            "imageUrl": "entrepreneurship-banner.jpg",
            "paperLinks": [
                "https://journals.lww.com/pain/fulltext/2024/11000/rna_isoform_expression_landscape_of_the_human.10.aspx"
            ]
        },
        {
            "title": "Interactome",
            "description": "This interactome analysis platform identifies potential signaling interactions between cell types of interest using transcriptomic data provided by the user and a curated ligand-receptor database.",
            "link": "https://sensoryomics.shinyapps.io/Interactome/",
            "imageUrl": "entrepreneurship-banner.jpg",
            "paperLinks": [
                "https://pubmed.ncbi.nlm.nih.gov/33727337/"
            ]
        },
        {
            "title": "Human and Mouse DRG Transcriptomics Dashboard",
            "description": "This Tableau combines three papers with one easy to search gene function. The main difference between this site and our other dashboards is the inclusion of animal model data.",
            "link": "http://paincenter.utdallas.edu/sensoryomics-dashboard",
            "imageUrl": "entrepreneurship-banner.jpg",
            "paperLinks": [
                "https://journals.lww.com/pain/fulltext/2018/07000/comparative_transcriptome_profiling_of_the_human.16.aspx",
                "https://academic.oup.com/brain/article/142/5/1215/5382382",
                "https://journals.lww.com/pain/fulltext/2020/07000/pharmacological_target_focused_transcriptomic.9.aspx"
            ]
        },
        {
            "title": "Proteomics",
            "description": "This site explores sex-based molecular differences in the peripheral nervous system (PNS), focusing on chronic pain disorders.The findings provide insights into functional differences in sensory and pain mechanisms, with implications for clinical translation.",
            "link": "https://sensoryomics.shinyapps.io/Proteomics/",
            "imageUrl": "entrepreneurship-banner.jpg",
            "paperLinks": [
                "https://journals.lww.com/pain/fulltext/2025/10000/multi_omic_integration_with_human_dorsal_root.21.aspx"
            ]
        },
        {
            "title": "Rat DRG",
            "description": "This RShiny application hosts a rat dorsal root ganglion (DRG) dataset generated from single-nucleus RNA sequencing. Users can explore gene expression patterns by searching for genes of interest and visualizing their expression across various plots.",
            "link": "https://sensoryomics.shinyapps.io/rat-drg/",
            "imageUrl": "entrepreneurship-banner.jpg",
            "paperLinks": [
                "https://www.biorxiv.org/content/10.1101/2025.02.19.639130v1"
            ]
        },
        {
            "title": "Human SCG",
            "description": "This R Shiny application hosts a human sympathetic chain ganglia (SCG) dataset generated using spatial RNA sequencing. Users can explore genes of interest and visualize their expression across multiple interactive plots.",
            "link": "https://sensoryomics.shinyapps.io/Human-SCG/",
            "imageUrl": "entrepreneurship-banner.jpg",
            "paperLinks": [
                "https://www.biorxiv.org/content/10.1101/2025.06.24.661373v1"
            ]
        },
        {
            "title": "Human Peripheral Nerves",
            "description": "This interactive R Shiny application presents two datasets focused on human peripheral nerves: one comparing control with DPN sural nerves, and another comparing paired sural with tibial nerves. Users can search for genes of interest and visualize their expression through intuitive, interactive box plots.",
            "link": "https://sensoryomics.shinyapps.io/human-peripheral-nerves/",
            "imageUrl": "entrepreneurship-banner.jpg",
            "paperLinks": [
                "https://www.jci.org/articles/view/184075"
            ]
        },
        {
            "title": "Human Surgical C2DRG",
            "description": "This interactive R Shiny application enables users to search for genes of interest within human C2 dorsal root ganglion (DRG) neuronal and non-neuronal cell populations. Users can explore gene expression patterns through intuitive, interactive visualizations.",
            "link": "https://sensoryomics.shinyapps.io/human-surgical-c2drg/",
            "imageUrl": "entrepreneurship-banner.jpg",
            "paperLinks": [
                "https://academic.oup.com/brain/advance-article/doi/10.1093/brain/awaf370/8270764?login=true"
            ]
        },
        {
            "title": "Human Spinal Dorsal and Ventral Horn",
            "description": "This interactive R Shiny application enables users to explore gene expression in human spinal cord dorsal and ventral horn cell populations, including both neuronal and non‑neuronal cells. The app allows researchers to input a gene of interest and instantly visualize its expression patterns across defined cell types using intuitive, interactive plots.",
            "link": "https://sensoryomics.shinyapps.io/single-nuc-spinal-cord/",
            "imageUrl": "entrepreneurship-banner.jpg",
            "paperLinks": [
                "https://www.biorxiv.org/content/10.1101/2025.10.31.685953v2"
            ]
        },
        {
            "title": "Molecular architecture of human dermal sleeping nociceptors",
            "description": "This interactive R Shiny application lets users explore Patch-seq and snRNA-seq data from pig dorsal root ganglia, linking gene expression to electrophysiologically defined sensory neuron subtypes, including mechano-insensitive C-fibers. Users can input a gene to visualize expression across nociceptor populations.",
            "link": "https://sensoryomics.shinyapps.io/drg-patchseq/",
            "imageUrl": "entrepreneurship-banner.jpg",
            "paperLinks": [
                "https://www.cell.com/cell/fulltext/S0092-8674(25)01497-7"
            ]
        },
        {
            "title": "Spinal Signatures of Entrenched and Treated Neuropathic Pain in Male Mice",
            "description": "This interactive R Shiny application lets users explore a multimodal atlas of the spinal cord in neuropathic pain, comparing molecular signatures before and after treatment. Users can input a gene to explore the cellular and molecular mechanisms underlying persistent pain and recovery.",
            "link": "https://sensoryomics.shinyapps.io/SC_Visium_Dashboard/",
            "imageUrl": "entrepreneurship-banner.jpg",
            "paperLinks": [
                "https://www.nature.com/articles/s41467-026-74144-3"
            ]
        }
    ]
};